import { DateTime } from 'luxon'

export default (strDate, { fmtIn = 'yyyy-MM-dd HH:mm:ss', fmtOut = 'dd/MM/yyyy | HH:mm:ss' }) => {
  if (!strDate) return '-'
  if (fmtIn === 'iso') {
    return DateTime.fromISO(strDate).toFormat(fmtOut)
  }
  return DateTime.fromFormat(strDate, fmtIn).toFormat(fmtOut)
}
